<template>
  <div ref="searchDropdown" class="dropdown">
    <button v-if="color==='teal'" class="btn-regular" :class="{teal : isSet, secondary : !isSet}" @click.stop="toggledDropdown">{{labelDropdown}}</button>
    <button v-else class="btn-regular" :class="{pink : isSet, secondary : !isSet}" @click.stop="toggledDropdown">{{labelDropdown}}</button>
    <media :query="{minWidth: 769}">
      <div v-if="isShown" class="dropdown__menu" @click.stop="isShown = true">
        <div class="dropdown__input" :class="{'dropdown__input--focus':isFocus}" @click="setFocus">
          <span class="dropdown__input__icon__left"><i class="icon-search"></i></span>
          <input ref="input" type="text" class="dropdown__input__dropdown"
            @focus="onFocus" @blur="isFocus = false" @keyup="searchDevices" placeholder="Search">
          <span v-if="search != ''" @click.stop="clear" @mouseover="hasFocused" class="dropdown__input__icon__right"><i class="icon-clear"></i></span>
        </div>
        <div class="dropdown__menu__wrapper">
          <div class="notFound" v-if="isEmpty(filteredData)">
            <p>No matching any results ..</p>
          </div>
          <div class="content" v-else v-for="item in filteredData" :key="item.id">
            <div class="dropdown__menu__wrapper__subtitle">{{ item.title }}</div>
            <div class="dropdown__menu__wrapper__sub-item">
              <ul class="dropdown__menu__wrapper__sub-item__items">
                <li>
                  <div v-for="location in firstColumn2(item.locations)" :key="location.id"
                    @mouseover="selectedIndex(location.id)" :class="{selected: selected == location.id
                    || selectedValue == location.id.toString()}"
                    @click.stop="select(item.title, location)">
                      {{ location.location }}
                  </div>
                </li>
                <li>
                  <div v-for="location in secondColumn2(item.locations)" :key="location.id"
                    @mouseover="selectedIndex(location.id)" :class="{selected: selected == location.id
                    || selectedValue == location.id.toString()}"
                    @click.stop="select(item.title, location)">
                      {{ location.location }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </media>
    <media :query="{maxWidth: 769}">
      <modal v-if="isShown" :title="`Locations`" @modal-close="closeModal">
        <template slot="content">
          <div  class="dropdown__menu" @click.stop="isShown = true">
            <div class="dropdown__input" :class="{'dropdown__input--focus':isFocus}" @click="setFocus">
              <span class="dropdown__input__icon__left"><i class="icon-search"></i></span>
              <input ref="input" type="text" class="dropdown__input__dropdown"
                @focus="onFocus" @blur="isFocus = false" @keyup="searchDevices" placeholder="Search">
              <span v-if="search != ''" @click.stop="clear" @mouseover="hasFocused" class="dropdown__input__icon__right"><i class="icon-clear"></i></span>
            </div>
            <div class="dropdown__menu__wrapper">
              <div class="notFound" v-if="isEmpty(filteredData)">
                <p>No matching any results ..</p>
              </div>
              <div class="content" v-else v-for="item in filteredData" :key="item.id">
                <div class="dropdown__menu__wrapper__subtitle">{{ item.title }}</div>
                <div class="dropdown__menu__wrapper__sub-item">
                  <ul class="dropdown__menu__wrapper__sub-item__items">
                    <li>
                      <div v-for="location in firstColumn2(item.locations)" :key="location.id"
                        @mouseover="selectedIndex(location.id)" :class="{selected: selected == location.id
                        || selectedValue == location.id.toString()}"
                        @click.stop="select(item.title, location)">
                          {{ location.location }}
                      </div>
                    </li>
                    <li>
                      <div v-for="location in secondColumn2(item.locations)" :key="location.id"
                        @mouseover="selectedIndex(location.id)" :class="{selected: selected == location.id
                        || selectedValue == location.id.toString()}"
                        @click.stop="select(item.title, location)">
                          {{ location.location }}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </template>
      </modal>
    </media>

  </div>
</template>
<script>
import Vue from 'vue'
import Media from 'vue-media'
import Modal from '@/components/Modal'
import NotFound from '@/components/NotFound'

export default {
  name: 'adx-dropdown-search',
  components:{
    'media': Media,
    'modal': Modal,
    'not-found': NotFound
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    labelButton: {
      type: String,
      required: true
    },
    selectedValue: {
      type: String,
      required: false,
    },
    color: {
      required: false,
      default: 'teal'
    }
  },
  data() {
    return {
      search: '',
      isFocus: false,
      isFocused: false,
      isShown: false,
      isSet: false,
      selected: null,
      selectId: null,
      // labelDropdown: '',
      firstLabelDropdown: ''
    }
  },
  mounted() {
    this.$nextTick(function() {
      Vue.$broker.$on("app-click", this.closeDropdown.bind(this))
    })
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.isFocus = false
        this.search = ''
        this.closeDropdown()
      }
    })
    this.firstLabelDropdown = this.labelButton
  },
  updated() {
    this.$nextTick(function() {
      Vue.$broker.$on("app-click", this.closeDropdown.bind(this))
    })
  },
  methods: {
    toggledDropdown(sender) {
      Vue.$broker.$emit("app-click", this)
      this.isShown = !this.isShown
      this.search = ''
    },
    closeDropdown(sender) {
      if (sender === this || this.isFocus === true) {
        return
      }
      this.isShown = false
      this.selected = null
    },
    closeModal() {
      this.isShown = false
    },
    hasFocused() {
      if (this.isFocus) {
        this.isFocused = true
      } else {
        this.isFocused = false
      }
    },
    clear() {
      this.$refs.input.value = ''
      this.search = ''
      if (this.isFocused) this.$refs.input.focus()
    },
    select(title, item) {
      if (this.selected !== null) {
        if (item.id.toString() == this.selectedValue) {
          item = {"id":''}
          this.isSet = false
        } else {
          this.isSet = true
        }
        this.$emit('selected', item, title)
      }
      this.closeDropdown()
    },
    selectedIndex(index) {
      this.selected = index
    },
    setFocus() {
      this.onFocus()
      this.$refs.input.focus()
    },
    onFocus() {
      this.isFocus = true
    },
    boldWord(item) {
      if (item.id !== null) return item.location.slice(0, this.search.length)
    },
    sliceWord(item) {
      if (item.id !== null) {
        return item.location.slice(this.search.length)
      }
      return item.location
    },
    searchDevices(ev) {
      this.search = this.$refs.input.value
    },
    firstColumn2(data) {
      let dataLength = data.length
      let roundingUpResult = Math.ceil(dataLength/2)
      return data.slice(0, roundingUpResult)
    },
    secondColumn2(data) {
      let dataLength = data.length
      if (dataLength > 1) {
        let roundingUpResult = Math.ceil(dataLength/2)
        return data.slice(roundingUpResult, dataLength)
      } else {
        return []
      }
    },
    isEmpty(data) {
      const a = data.map(el => el.locations.length === 0)
      return !a.includes(false)
    }
  },
  watch: {
    selectedValue: function () {
      this.selected = this.selectedValue
      if (!this.selectedValue) {
        this.isSet = false
      }
    }
  },
  computed: {
    labelDropdown () {
      if (this.selectedValue) {
        let selectedItem = this.list
          .map(element => {
            return element.locations.map(child => {
              child.title = element.title
              return child
            })
          })
          .reduce((acc, val) => acc.concat(val), [])
        selectedItem = selectedItem.filter(el => el.id == this.selectedValue).pop()
        if (selectedItem) {
          this.isSet = true
          return `${selectedItem.title} - ${selectedItem.location}`
        }
      }
      return this.firstLabelDropdown
    },
    filteredData () {
      var filterList = []
      this.list.map((data) => {
        var locations = []
        data.locations.map((value) => {
          if (value.location.toLowerCase().startsWith(this.search.toLowerCase())) {
            locations.push(value)
          }
        })
        var filtered = {"id":data.id, "title": data.title}
        filtered.locations = locations
        filterList.push(filtered)
      })
      if (filterList.length < 0) {
        this.selected = null
      }
      return filterList
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>